const defaultTheme = {
  title: 'NFLIX2 PLUS',
  logo: '',
  background: '',
  primary_color: '#23aaff'
};

function setThemeVars(theme) {
  const primary = theme.primary_color || defaultTheme.primary_color;

  document.documentElement.style.setProperty('--theme-primary', primary);
  document.documentElement.style.setProperty('--theme-primary-dark', '#0c8bf1');
  document.documentElement.style.setProperty('--theme-primary-soft', `${primary}22`);
  document.documentElement.style.setProperty('--theme-primary-border', `${primary}55`);
  document.documentElement.style.setProperty('--theme-primary-glow', `${primary}66`);

  if (theme.background) {
    document.documentElement.style.setProperty(
      '--theme-page-bg',
      `linear-gradient(rgba(7,15,29,.88), rgba(7,15,29,.94)), url("${theme.background}") center center / cover fixed no-repeat`
    );
  } else {
    document.documentElement.style.setProperty(
      '--theme-page-bg',
      'radial-gradient(circle at center, #08233d, #07111f 70%)'
    );
  }
}

async function loadPublicTheme() {
  try {
    const response = await fetch('/painel/theme_public.php', { cache: 'no-store' });
    const data = await response.json();
    setThemeVars({ ...defaultTheme, ...data });
  } catch (error) {
    console.error('Erro ao carregar tema público:', error);
    setThemeVars(defaultTheme);
  }
}

loadPublicTheme();
